/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import BottomMenu from "./BottomMenu";
import {
  Grid,
  Avatar,
  Box,
  Button,
  Dialog,
  Slide,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { shadows } from "@mui/system";
import { useState, forwardRef, useEffect } from "react";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { useHistory } from "react-router-dom";
import ClearIcon from "@mui/icons-material/Clear";
import MypageEdit from "./MypageEdit";
import moment from "moment";
import { GetDayDifference } from "./GetDayDifference";
// import Calendar from 'react-calendar'
// import 'react-calendar/dist/Calendar.css';
import styled from "styled-components";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
import PickersDay from "@mui/lab/PickersDay";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link } from "react-router-dom";
import queryString from "query-string";
import pr from "../lib/pr";
import MypageLoggedCoupon from "./MypageLoggedCoupon";
import MypageLoggedReservation from "./MypageLoggedReservation";
import MypageLoggedPayment from "./MypageLoggedPayment";
import { configState } from "../lib/State";
import get_token from "../lib/get_token";
import axios from "axios";
import { parse } from "date-fns";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createTheme({
  components: {
    MuiTabPanel: {
      styleOverrides: {
        root: {
          position: "absolute",
          top: "250px",
          width: "100%",
          padding: "24px",
        },
      },
    },
  },
});
const calTheme = createTheme({
  components: {
    MuiPickerStaticWrapper: {
      styleOverrides: {
        root: {
          maxHeight: "280px",
          height: "100%",
        },
      },
    },
  },
});

// function LinkTab(props) {
//     return (
//         <Tab
//             component="a"
//             onClick={event => {
//                 event.preventDefault();
//             }}
//             {...props}>
//         </Tab>
//     )
// }

function MypageLoggedin(props) {
  // URL에서 탭 바꾸기
  let { tab } = queryString.parse(window.location.search);
  if (tab === undefined) tab = "1";
  const [value, setValue] = useState(tab);

  const { login } = props;
  const history = useHistory();
  const [showDetail, setShowDetail] = useState(false);
  const [name, setName] = useState("");
  const cid = get_cid();
  const center = get_center(cid);
  // const active = props.active;

  // const [value, setValue] = useState(active);

  const handleChange = (event, newValue) => {
    history.push("/mypage?tab=" + newValue);
    setValue(newValue);
  };

  const clickshowDetail = () => {
    setShowDetail(true);
  };
  const clickCloseDetail = () => {
    setShowDetail(false);
  };

  // const [rows, setRows] = useState([]);
  // const handle_reservation = (params) => {
  //     const { coupon_seq, pt_type } = params;
  //     GoPage(
  //       "pt_reservation",
  //       cid + "&coupon_seq=" + coupon_seq + "&pt_type=" + pt_type
  //     );
  //   };

  const [date, setDate] = useState();
  const minDate = new Date(moment().add(-1, "years"));
  const maxDate = new Date(moment().add(+1, "years"));

  // 회원정보
  const load_data = async () => {
    const token = get_token();
    let result = await axios.post(configState.api + "/gympass/get_member_one", {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    });
    setName(result.data.member.name);
  };
  useEffect(() => {
    if (login.mcd !== "") {
      load_data();
    }
  }, [login.mcd]);

  return (
    <Grid
      container
      height={cid !== "XXXXX" /*줌*/ ? "100vh" : "100%"}
      direction="column"
      overflow="hidden"
    >
      <Dialog
        fullScreen
        open={showDetail}
        TransitionComponent={Transition}
        onClose={clickCloseDetail}
      >
        <Box
          sx={{
            width: "90%",
            textAlign: "left",
            padding: "30px 0 10px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <img src="/img/back_button_black.png" onClick={clickCloseDetail} />
          <Box
            sx={{
              margin: "25px 0 0 10px",
              fontSize: "22px",
            }}
          >
            정보수정
          </Box>
        </Box>
        <Divider />
        <MypageEdit login={login} onClose={clickCloseDetail}></MypageEdit>
      </Dialog>
      <Box
        sx={{
          width: "100%",
          height: "50px",
          background: "black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={center.logo} height="35px" />
      </Box>
      <Box
        style={{
          position: "relative",
          // top: 0,
          width: "100%",
          height: "260px",
          overflow: "hidden",
          zIndex: 10,
        }}
      >
        <img src="/img/mypage_header_noword.png" style={{ width: "100%" }} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",

            // fontWeight: 'bold'
          }}
        >
          <Box
            sx={{
              fontSize: "46px",
              fontFamily: "BebasNeue",
              color: "white",
            }}
          >
            MYPAGE
          </Box>
          {/* <Box
            sx={{
              fontSize: "18px",
              color: "white",
              fontWeight: "bold",
              textAlign: "center",
              marginTop: "-6px",
            }}
          >
            내수업
          </Box> */}
        </Box>
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: "255px",
          left: "50%",
          transform: "translate(-50%, 0)",
          zIndex: 20,
        }}
        onClick={clickshowDetail}
      >
        <Avatar
          sx={{
            width: cid !== "XXXXX" /*줌*/ ? "12vh" : "7rem",
            height: cid !== "XXXXX" /*줌*/ ? "12vh" : "7rem",
            border: "solid white 1px",
            boxShadow: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flexWrap: "wrap",
            alignContent: "center",
            // marginTop: "20px",
            // marginBottom: "10px",
          }}
        >
          <Box
            sx={{
              marginBottom: "5px",
              color: "black",
              fontWeight: "bold",
            }}
          >
            {name}
          </Box>
          <Box
            sx={{
              fontSize: "13px",
              display: "flex",
              alignItems: "center",
              position: "absolute",
              bottom: 10,
            }}
            // onClick={clickshowDetail}
          >
            <img src="/img//edit.png" style={{ height: "13px" }} /> EDIT
          </Box>
        </Avatar>
      </Box>
      <Grid container direction="column" width="100%">
        <TabContext value={value} variant="fullWidth">
          <ThemeProvider theme={theme}>
            <TabList
              onChange={handleChange}
              sx={{
                "& .MuiTabs-flexContainer": {
                  width: "100%",
                  height: "100px",
                  justifyContent: "space-around",
                  // position: "",
                  // top: '0px',
                  // zIndex: 3,
                  // background: "white",
                  alignItems: "flex-end",
                },
                "& .MuiTabs-root": {
                  width: "100%",
                },
                ["& .MuiTab-root"]: {
                  color: "black",
                },
                "& .MuiButtonBase-root": {
                  color: "black",
                  maxHeight: "40px",
                  height: "100%",
                },
                ["&& .Mui-selected"]: {
                  fontWeight: "bold",
                  color: "black",
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#0092a2",
                  // position: "absolute",
                  // top: '360px',
                  // top: 248,
                  // zIndex: 5,
                },
              }}
            >
              <Tab
                label="내수업"
                value="1"
                // component={Link}
                // to="/mypage?value='1'"
              ></Tab>
              <Tab
                label="내쿠폰"
                value="2"
                // component={Link}
                // to="/mypage?value='2'"
              ></Tab>
              <Tab
                label="구매내역"
                value="3"
                // component={Link}
                // to="/mypage?value='3'"
              ></Tab>
            </TabList>
            <TabPanel value="1" sx={{ width: "100%", padding: 0 }}>
              <MypageLoggedReservation login={login} />
            </TabPanel>

            <TabPanel value="2" sx={{ width: "100%", padding: 0 }}>
              <MypageLoggedCoupon login={login} />
            </TabPanel>

            <TabPanel value="3" sx={{ width: "100%", padding: 0 }}>
              <MypageLoggedPayment login={login} />
            </TabPanel>
          </ThemeProvider>
        </TabContext>
      </Grid>
      {/* <Grid
                // flex="1"
                width="100%"
                height="100%"
                // direction="column"
                justifyContent="space-around"
                alignItems="center"
            >
                <Grid
                    // container
                    // flex="1"
                    // width="100%"
                    // height="50vh"
                    // direction="column"
                    // justifyContent="center"
                    // alignItems="center"
                    // sx={{position: "fixed"}}
                    container
                    display="flex"
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        width: "100%",
                        height: "180px",
                        background: "white",
                        marginTop: "20px",
                        position: "fixed",
                        top: 0,
                        zIndex: 5,
                        // height: ''
                    }}
                >
                    <Avatar
                        sx={{
                            width: "12vh",
                            height: "12vh",
                            border: "solid white 1px",
                            boxShadow: 2,
                            marginTop: "20px",
                            marginBottom: "10px",
                        }}
                        onClick={clickshowDetail}
                    >
                        {name}
                    </Avatar>
                    <Dialog
                        fullScreen
                        open={showDetail}
                        TransitionComponent={Transition}
                        onClose={clickCloseDetail}
                    >
                        <Grid
                            className="header"
                            container
                            direction="row"
                            justifyContent="space-between"
                            sx={{
                                width: "100%",
                                padding: "5px",
                                fontSize: "20px",
                                background: "#0092a2",
                                color: "white",
                            }}
                        >
                            정보수정
                            <ClearIcon onClick={clickCloseDetail}></ClearIcon>
                        </Grid>
                        <PersonalInfo login={login} onCloseClick={clickCloseDetail}></PersonalInfo>
                    </Dialog>
                    <Box style={{ textAlign: "center" }}><Typography onClick={clickshowDetail}>정보수정</Typography></Box>
                </Grid>
                <Grid
                    container
                    // height="100%"
                    // height="70%"
                    width="100%"
                    sx={{ position: "relative" }}
                >
                    <TabContext value={value} variant="fullWidth">
                        <ThemeProvider theme={theme}>
                            <TabList
                                onChange={handleChange}
                                sx={{
                                    "& .MuiTabs-flexContainer": {
                                        width: "100%",
                                        // height: "100px",
                                        justifyContent: "space-around",
                                        position: "fixed",
                                        top: 200,
                                        zIndex: 3,
                                        background: "white",
                                    },
                                    "& .MuiTabs-root": {
                                        width: "100%",
                                    },
                                    ["& .MuiTab-root"]: {
                                        color: "black",
                                    },
                                    "& .MuiButtonBase-root": {
                                        color: "black",
                                        maxHeight: 40,
                                        height: "100%",
                                    },
                                    ["&& .Mui-selected"]: {
                                        fontWeight: "bold",
                                        color: "black",
                                    },
                                    "& .MuiTabs-indicator": {
                                        backgroundColor: "#0092a2",
                                        position: "fixed",
                                        top: 248,
                                        zIndex: 5,
                                    },
                                }}
                            >
                                <Tab
                                    label="예약현황"
                                    value="1"
                                    component={Link}
                                    to="/profile"
                                ></Tab>
                                <Tab
                                    label="쿠폰"
                                    value="2"
                                    component={Link}
                                    to="/profile/coupon"
                                ></Tab>
                                <Tab
                                    label="구매내역"
                                    value="3"
                                    component={Link}
                                    to="/profile/payment"
                                ></Tab>
                            </TabList>
                            <TabPanel
                                value="1"
                                sx={{ width: "100%", padding: '24px 0' }}

                            //   variant="scrollable" sx={{ overflow: "scroll" }}
                            >
                                <ProfileLoggedReservation login={login} />
                            </TabPanel>

                            <TabPanel value="2" sx={{ width: "100%", padding: "24px 0" }}>
                                <ProfileLoggedCoupon login={login} />
                            </TabPanel>

                            <TabPanel
                                value="3"
                                sx={{ width: '100%', padding: '24px 0' }}
                            >
                                <ProfileLoggedPayment login={login} />
                            </TabPanel>
                        </ThemeProvider>
                    </TabContext>
                </Grid>
            </Grid> */}
      <BottomMenu></BottomMenu>
    </Grid>
  );
}

export default MypageLoggedin;
